import { render, staticRenderFns } from "./ChatGroupOrderSide.vue?vue&type=template&id=4cc41ff0&scoped=true"
import script from "./ChatGroupOrderSide.vue?vue&type=script&lang=js"
export * from "./ChatGroupOrderSide.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupOrderSide.vue?vue&type=style&index=0&id=4cc41ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc41ff0",
  null
  
)

export default component.exports